import Masonry from "masonry-layout";
var imagesLoaded = require('imagesloaded');

/**
 * TOP、CONTENTSのグリッドレイアウト
 * @constructor
 */
class Panel {
  constructor() {

  }
  /**
   * TOP、CONTENTSのグリッドレイアウト
   */
  init() {

    //masonry
    // imagesLoaded('.l-panelList', function () {
      // images have loaded
      var sp = window.matchMedia("(max-width: 750px)").matches;
      if (sp) {
        //SPのとき
        var msnry = new Masonry('.l-panelList', {
          horizontalOrder: true,
          itemSelector: '.l-panelList__item',
          columnWidth: 9,
          gutter: 15,
        });
      } else {
        //PCのとき
        var msnry = new Masonry('.l-panelList', {
          itemSelector: '.l-panelList__item',
          columnWidth: 344,
          horizontalOrder: true,
        })
      }
    // });


  //タブを押すとソートされる
    let categoryBtn;
    categoryBtn = $('.category-btn').find('a');
    categoryBtn.each(function () {
      $(this).on('click', function (e) {
        var selected = $(this).attr('class');
        console.log(selected);
        e.preventDefault();

        categoryBtn.removeClass('is-current');
        $(this).addClass('is-current');

        $('body').removeClass(function (index, className) {
          return (className.match(/\bcategory-\S+/g) || []).join(' ');
        }).addClass('category-' + selected);
        var sp = window.matchMedia("(max-width: 750px)").matches;
        if (sp) {
          //SPのとき
          var msnry = new Masonry('.l-panelList', {
            horizontalOrder: true,
            itemSelector: '.l-panelList__item',
            columnWidth: 9,
            gutter: 15,
          });
        } else {
          //PCのとき
          var msnry = new Masonry('.l-panelList', {
            itemSelector: '.l-panelList__item',
            columnWidth: 344,
            horizontalOrder: true,
          })
        }
      });
    });

    // TOPのタブ押してソートした状態で遷移完了
    let hash = location.hash;
    let tabname = hash.slice(5);//「#tab_」の5文字削除
    let urlPara = document.URL;
    // imagesLoaded('.l-panelList', function () {
      // images have loaded
      if (urlPara.match(/#tab_/)) {
        $('body').removeClass();
        $('body').addClass('category-' + tabname);
        var sp = window.matchMedia("(max-width: 750px)").matches;
        if (sp) {
          //SPのとき
          var msnry = new Masonry('.l-panelList', {
            horizontalOrder: true,
            itemSelector: '.l-panelList__item',
            columnWidth: 9,
            gutter: 15,
          });
        } else {
          //PCのとき
          var msnry = new Masonry('.l-panelList', {
            itemSelector: '.l-panelList__item',
            columnWidth: 344,
            horizontalOrder: true,
          })
        }
      }
    // })
  }
}

export default Panel;
